import { useState } from 'react';

export const useTypingEffect = () => {
    const [completedTypingIds, setCompletedTypingIds] = useState(new Set());

    const handleComplete = (id) => {
        setCompletedTypingIds((prev) => {
            const newSet = new Set(prev);
            newSet.add(id);
            return newSet;
        });
    };
    const resetTyping = () => setCompletedTypingIds(new Set());

    return { completedTypingIds, handleComplete, resetTyping };
};
